<template>
  <div class="flex col">
    <IconLink icon="fluent:building-shop-24-regular" to="/">
      {{ $tt('brand.name') }}
    </IconLink>
    <IconLink icon="uil:hourglass" to="/status">
      {{ $tt('visa_status') }}
    </IconLink>
    <IconLink v-if="$branch.blog" icon="mdi:blog-outline" to="/blog">
      {{ $tt('blog.blog') }}
    </IconLink>
    <IconLink icon="mdi:heart-outline" to="/about">
      {{ $tt('about_us') }}
    </IconLink>
    <IconLink icon="ri:scales-3-fill" to="/terms">
      {{ $tt('terms_of_use') }}
    </IconLink>
    <IconLink icon="uil:lock" to="/privacy">
      {{ $tt('privacy_policy') }}
    </IconLink>
  </div>
</template>